import {IOrganizationAdvertiserLogin} from "../../../organizations/interfaces/IOrganizationAdvertiserLogin";
import {Grid, AlertTypes, FormChips, MainLoader} from "@leap4/frontend";
import React, {useContext, useEffect, useState} from "react";
import {IAdvertiserLogins} from "../../interfaces/IAdvertiserLogins";
import {ApiClient} from "../../../../utils/apiClient";
import {organizationPartnersUrl} from "../../../../config/generals";
import {setAlert} from "../../../../actions/alert";
import {AdvertiserLoginContext} from "../AdvertiserLoginContext";

export interface IAdvertiserLoginsProps {
    currentAdvertiserLogin: IAdvertiserLogins
}

export interface IOrganizationPartners {
    org: IOrganizationAdvertiserLogin,
    optionalPartners: string[],
    selectedPartners: string[]
}

export const PartnerContainer = (props: IAdvertiserLoginsProps) => {
    const {advertiserLogin, setAdvertiserLogin} = useContext(AdvertiserLoginContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [allPartners, setAllPartners] = useState<{id: string, name: string}[]>([]);

    const updatePartners = (items: string[]) => {
        setAdvertiserLogin({
            ...advertiserLogin,
            demandPartners: items
                .map(item => allPartners.find(p => p.id === item))
                .filter(Boolean) as {id: string, name: string}[]
        })
    }

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                const allData = (await ApiClient.get(organizationPartnersUrl, {params: {organization: props.currentAdvertiserLogin.advertiserLoginId.toString()}})).data;
                if (!allData || !allData?.length) {
                    return;
                }
                setAllPartners(allData);
            } catch (e: any) {
                setAlert(e.toString(), AlertTypes.FAILURE)
            } finally {
                setIsLoading(false);
            }
        })()
    }, [props.currentAdvertiserLogin.advertiserLoginId])

    if (isLoading) return <Grid item padding={0}>
        <MainLoader/>
    </Grid>;
    return (
        <>
            <Grid margin={"30px"}>
            </Grid>
            <Grid item width='100%' margin={"0px"}>
                <FormChips optionsList={allPartners}
                           onUpdateItems={updatePartners}
                           inputName={"Demand Partners"}
                           enableCreate={false}
                           chips={(advertiserLogin.demandPartners || []).map(partner => partner.id.toString())}
                           pureCreate={false}
                           textFieldProps={{size: "small", style: {width: "100%"}}}
                           stackProps={{style: {width: "100%"}}}
                           labelKey={"name"}
                           valueKey={"id"}
                           disableCloseOnSelect={false}
                />
            </Grid>
        </>
    )
}
